import { ApiCoupon } from '@/models/api/coupon'

export const initialCouponState: CouponState = {
  coupons: [],
  couponCode: {
    inputtingText: '',
  },
}

export interface CouponState {
  coupons: ApiCoupon[]
  couponCode: {
    /**
     * 入力中のクーポンコードテキスト
     * @see https://github.com/my-color/front/issues/6309 入力中のクーポンコードテキストを保持するようにした背景
     * @note
     * 元issueで問題になっていたのは「クーポン欄を開閉すると入力中コードが消える」であって「画面を移動すると入力中コードが消える」ではなかった.
     * （「画面を移動すると"適用状態が解除される"というissueは https://github.com/my-color/front/issues/6367 がある）
     * 入力中コードの維持が必要なのは「クーポン欄を開閉」した時であって画面移動までは含まなくてよかったのだとすると、
     * 入力中テキストをstoreに保存するまでせずとも、<keep-alive>を使うぐらいで十分だったかもしれない
     * 参照: https://v2.ja.vuejs.org/v2/api/#keep-alive
     */
    inputtingText: string
  }
  loadError?: Error
}
